/**
 * Dates as the registry prints them — the one definition.
 *
 * en-GB throughout, because the format a dealer writes — "04 Feb 2026" — is
 * the one the design prints, and a date that read differently for two people
 * looking at the same record would be two facts where the record has one.
 *
 * IT LIVES HERE BECAUSE THE SERVER PRINTS DATES NOW. It was
 * `apps/web-frontend/src/lib/dates.ts` alone until OND-67, which moved the
 * collector-list export off the browser: the server builds the file, so the
 * server writes the "Last activity" column, and the file and the screen have
 * to agree about what a day looks like. `lib/dates.ts` re-exports this one
 * rather than keeping a second body — four screens had byte-identical copies
 * of the short form before it was lifted there, and lifting it again for the
 * same reason is the pattern working, not a new one.
 */
/**
 * '04 Feb 2026'. The short form, and the default everywhere a row has a date.
 *
 * `fallback` is what an unreadable or missing instant prints — an empty string
 * by default, so a malformed timestamp leaves a gap rather than the string
 * "Invalid Date" in the middle of a sentence about somebody's money. `utc`
 * pins the day: an attestation stamped near midnight must not shift a day
 * between readers in different zones, and it is what the SERVER passes, whose
 * zone is nobody's. `day: "numeric"` drops the leading zero — '2 Mar 2026' —
 * for the one card whose design prints it that way.
 */
export function formatRegistryDay(iso, { locale = "en-GB", utc = false, fallback = "", day = "2-digit", } = {}) {
    if (!iso)
        return fallback;
    const at = new Date(iso);
    if (Number.isNaN(at.getTime()))
        return fallback;
    return at.toLocaleDateString(locale, {
        day,
        month: "short",
        year: "numeric",
        ...(utc ? { timeZone: "UTC" } : {}),
    });
}
//# sourceMappingURL=dates.js.map